var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33334 0C1.96534 0 1.66668 0.298667 1.66668 0.666667C1.66668 1.03467 1.96534 1.33333 2.33334 1.33333H11.6667C12.0347 1.33333 12.3333 1.03467 12.3333 0.666667C12.3333 0.298667 12.0347 0 11.6667 0H2.33334ZM2.07814 2.66667C1.82547 2.66667 1.59575 2.80916 1.48308 3.03516L0.403656 5.19271C0.356989 5.28538 0.333344 5.38755 0.333344 5.49089V6C0.333344 6.368 0.63201 6.66667 1.00001 6.66667V10.6667C1.00001 11.4033 1.59668 12 2.33334 12H11.6667C12.4033 12 13 11.4033 13 10.6667V6.66667C13.368 6.66667 13.6667 6.368 13.6667 6V5.49089C13.6667 5.38755 13.643 5.28537 13.5964 5.19271L12.5169 3.03516C12.4043 2.80916 12.1746 2.66667 11.9219 2.66667H2.07814ZM3.00001 6.66667H11C11.368 6.66667 11.6667 6.96533 11.6667 7.33333V10C11.6667 10.368 11.368 10.6667 11 10.6667H3.00001C2.63201 10.6667 2.33334 10.368 2.33334 10V7.33333C2.33334 6.96533 2.63201 6.66667 3.00001 6.66667Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyIcon);
export default __webpack_public_path__ + "static/media/reply-icon.7f640f539b95606b7def51bcb8447af1.svg";
export { ForwardRef as ReactComponent };